import { render, staticRenderFns } from "./Waybills.vue?vue&type=template&id=c8eda8f6&scoped=true&"
import script from "./Waybills.vue?vue&type=script&lang=js&"
export * from "./Waybills.vue?vue&type=script&lang=js&"
import style0 from "./Waybills.vue?vue&type=style&index=0&id=c8eda8f6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8eda8f6",
  null
  
)

export default component.exports